import { render, staticRenderFns } from "./Orange.vue?vue&type=template&id=526bbbcc&scoped=true"
import script from "./Orange.vue?vue&type=script&lang=js"
export * from "./Orange.vue?vue&type=script&lang=js"
import style0 from "./Orange.vue?vue&type=style&index=0&id=526bbbcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526bbbcc",
  null
  
)

export default component.exports